export default {
      id: "more-usage",
      viewBox: "0 0 18 4",
      url: __webpack_public_path__ + "sprite-a10b6d.svg#more-usage",
      toString: function () {
        return this.url;
      }
    }